import { cx } from '@linaria/core';
import { ButtonHTMLAttributes } from 'react';
import Button from './Button';
import "./IconButton.linaria.module.css!=!./IconButton?./IconButton.linaria.module.css?css=H4sIAAAAAAAAA3WU29KbIBSF7/sUuelMe8E/4iFN7MMwiKAYBAPbU5y+eycxmkDTK2fB+nDvDbO+KLREGSLjEdL0y1NLR8tS6gqB6fJjN/3+8201cM/OQ3thAEzrERePuISE4gI8v/L8KvRbWdUecHYEwzTKQS2ldJ2icy4U37epJbjoUnNhgVzuLlRKyxlIo3NmVN/qDSs4wdczY9UtkCs2Wtrl2tw/+49aguMkOZr15Dw6RAfag9n2BSO4PpqmvwVyaXoHUsyIGQ1cQ864Bm43rvawXS1UyUojCbx1AWGT3QR8AvRwBp5h2BsaawkcuY4yHrTETkRAJVXsq0UYDcjJG89Pr3v4pQgeHZZdtjCjjM0Han8gVPQARqOCsktlTa/LnxuQNQQ7V8iyXgpjS26RpaXsXZ5F3zdPlZC0qU7nzFeLkpqjmj/egja2pWojsJXJFVOCsUhUP+eldLRQvDy4oVqEVOpZ17aOJDPa7UVp6UaZfabf2/oPjmfBs5QTPMbiOsQ7/3Ekj6Z3dBp600wEN/GpmeIPS6/DXsNE67lgqXYdtVzD23Sft+UPN7ixIRmjs/XKqyyfUSvYXtnZ1vVIuvaa0Q9zaB/v1lIHwSzuYVJ2okp95UVL9B4sb2Yemp/BEr3FCp7T1CgRSD9YUi9YPEL9Q6zRsiJ/AR5jSFkdBQAA"
const iconButtonStyles = "atm_lo_i2wt44 atm_le_i2wt44 atm_lk_i2wt44 atm_ll_i2wt44 atm_9s_1txwivl atm_ar_1bp4okc atm_be_1q9ccgz atm_am_12336oc atm_fc_1h6ojuz atm_h_1h6ojuz atm_r3_1h6ojuz atm_vv_1q9ccgz atm_c8_ftgil2 atm_7l_1ws1ip5 atm_5j_1ssbidh atm_g3_4jg895 atm_1ri3q1a_11f3luy atm_niswi5_11f3luy atm_1yfe54e_1w2fqv2 atm_xvuojx_1j28jx2";
const labelStyles = "atm_5j_ftgil2";
const dimStyles = "atm_7l_1v3w09r atm_9rhhw_pmq5a";
const noVerticalPadding = "atm_lo_idpfg4 atm_le_idpfg4 atm_lk_1y44olf atm_ll_1y44olf";
export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ref?: any;
  allowOverflow?: boolean;
  children?: any;
  dim?: boolean;
  showLabel?: boolean;
  zeroVerticalPadding?: boolean;
}
const IconButton = (props: IconButtonProps) => {
  const {
    ref,
    children,
    className,
    dim = false,
    showLabel = false,
    zeroVerticalPadding = false,
    ...rest
  } = props;
  return <Button ref={ref} clean size="small" disableElevation {...rest} className={cx('icon-button', iconButtonStyles, showLabel ? labelStyles : null, zeroVerticalPadding ? noVerticalPadding : null, dim ? dimStyles : null, className)}>
            {children}
        </Button>;
};
export default IconButton;